'use client';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';

export function useAuthenticated() {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  return authStatus === 'authenticated';
}

export type CurrentUserAttributes = Awaited<ReturnType<typeof fetchUserAttributes>>;

export function useUserAttributes() {
  const [user, setUser] = useState<CurrentUserAttributes | undefined>();

  useEffect(() => {
    fetchUserAttributes()
      .then(userAttributes => setUser(userAttributes))
      .catch(error => {
        console.error('Error fetching user attributes:', error);
        setUser(undefined);
      });
  }, []);

  return user;
}
